<template lang="pug">
  div
    VeeField(
      name="pickupLiftSize"
      v-slot="{ field, errors }"
    )
      SelRefined(
        v-bind="field"
        :value="liftSizeValue"
        @input="handleLiftSize"
        custom-classes="!rounded-t-none !border-t-0"
        :options="getLiftSizeOptions"
        option-text="name"
        option-value="value"
        :placeholder="$t('location_form.lift_size')"
        indicator
        qa-tag="sel_pickup_lift_size")
      VeeErrorMessage(name="pickupLiftSize")
        TextInputError(class="my-ds-sm")
          | {{ $t('location_form.error.lift_size') }}
</template>

<script lang="ts">
import { defineComponent } from "vue"
import { mapActions, mapGetters } from "vuex"
import {
  GET_PICKUP_LIFT_AVAILABLE,
  GET_PICKUP_LIFT_TYPE,
  SET_PICKUP_LIFT_AVAILABLE,
  SET_PICKUP_LIFT_TYPE
} from "~/store/listing"
import {
  LIFT_AVAILABLE,
  LIFT_UNAVAILABLE,
  LIFT_TYPE_NO_LIFT,
  LIFT_TYPE_STANDARD,
  LIFT_TYPE_LARGE,
  LIFT_TYPE_EXTRA_LARGE
} from "~/constants/listing"

export default defineComponent({
  name: "LiftAvailablePickupSel",

  props: {},
  computed: {
    ...mapGetters("listing", {
      getPickupLiftAvailable: GET_PICKUP_LIFT_AVAILABLE,
      getPickupLiftType: GET_PICKUP_LIFT_TYPE,
    }),
    getLiftSizeOptions(): LiftSizeOption[] {
      return [
        {
          name: this.$t("location_form.lift_no_lift") as string,
          value: LIFT_TYPE_NO_LIFT
        },
        {
          name: this.$t("location_form.lift_small") as string,
          value: LIFT_TYPE_STANDARD
        },
        {
          name: this.$t("location_form.lift_medium") as string,
          value: LIFT_TYPE_LARGE
        },
        {
          name: this.$t("location_form.lift_large") as string,
          value: LIFT_TYPE_EXTRA_LARGE
        }
      ]
    },
    liftSizeValue(): string | null {
      if (this.getPickupLiftAvailable === LIFT_UNAVAILABLE) {
        return LIFT_TYPE_NO_LIFT
      }
      if (this.getPickupLiftAvailable === LIFT_AVAILABLE && this.getPickupLiftType) {
        return this.getPickupLiftType
      }
      return null
    },
  },
  methods: {
    ...mapActions("listing", {
      setLiftAvailable: SET_PICKUP_LIFT_AVAILABLE,
      setLiftType: SET_PICKUP_LIFT_TYPE
    }),
    handleLiftSize(value: string): void {
      if (value === LIFT_TYPE_NO_LIFT) {
        this.setLiftAvailable(LIFT_UNAVAILABLE)
        this.setLiftType(value)
      } else {
        this.setLiftAvailable(LIFT_AVAILABLE)
        this.setLiftType(value)
      }
    }
  }
})
</script>
